import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "./adminApi";

export default function AdminLogin() {
  const nav = useNavigate();

  // keep your defaults (you can set "" if you want empty)
  const [email, setEmail] = useState("admin@test.com");
  const [password, setPassword] = useState("Admin@123");

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      setLoading(true);

      const res = await api.post("/api/auth/login", { email, password });

      // backend should return { token, admin: { name, email } } OR { token, name }
      const token = res.data?.token;
      const name = res.data?.admin?.name || res.data?.name || "Admin";

      if (!token) throw new Error("Token not returned from server");

      localStorage.setItem("token", token);
      localStorage.setItem("admin_name", name);

      nav("/admin/dashboard", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.message || ex?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Header row: title + home */}
        <div style={styles.headerRow}>
          <div>
            <div style={styles.title}>Admin Login</div>
            <div style={styles.subtitle}>Enter your credentials to access the dashboard.</div>
          </div>

          <button type="button" style={styles.btnSecondary} onClick={() => nav("/")}>
            ← Home
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit}>
          <label style={styles.labelWrap}>
            <span style={styles.labelText}>Username</span>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              style={styles.input}
              placeholder="admin@test.com"
            />
          </label>

          <label style={{ ...styles.labelWrap, marginTop: 16 }}>
            <span style={styles.labelText}>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              style={styles.input}
              placeholder="••••••••"
            />
          </label>

          {err ? <div style={styles.errBox}>{err}</div> : null}

          <button
            type="submit"
            disabled={loading}
            style={{ ...styles.btnPrimary, marginTop: 22, opacity: loading ? 0.85 : 1 }}
          >
            {loading ? "Signing in…" : "Login to Dashboard"}
          </button>

          <div style={styles.helpText}>
            Having trouble logging in? Contact your system administrator.
          </div>
        </form>
      </div>
    </div>
  );
}

/* ---------------- Styles (same feel as your reference) ---------------- */

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    background:
      "radial-gradient(circle at top, #e0f2fe 0, #f9fafb 45%, #e5e7eb 100%)",
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
  },

  card: {
    width: "100%",
    maxWidth: 520,
    borderRadius: 28,
    background: "#ffffff",
    boxShadow: "0 24px 60px rgba(15,23,42,0.08)",
    padding: "26px 28px 28px",
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 20,
    flexWrap: "wrap",
  },

  // font like your screenshot: only title strong, rest normal
  title: {
    fontSize: 28,
    fontWeight: 800,
    color: "#0f172a",
    letterSpacing: "-0.4px",
    lineHeight: 1.05,
  },
  subtitle: {
    fontSize: 13,
    color: "#6b7280",
    marginTop: 6,
    fontWeight: 500,
  },

  labelWrap: { display: "block", marginTop: 6 },
  labelText: {
    fontSize: 13,
    color: "#64748b",
    marginBottom: 6,
    display: "block",
    fontWeight: 500,
  },

  input: {
    width: "100%",
    height: 46,
    padding: "0 14px",
    borderRadius: 999,
    border: "1px solid #cbd5e1",
    fontSize: 14,
    outline: "none",
    background: "#eff6ff",
    fontWeight: 600,
  },

  btnPrimary: {
    width: "100%",
    height: 48,
    borderRadius: 999,
    border: 0,
    background: "linear-gradient(135deg,#0f766e 0%,#22c55e 40%,#0ea5e9 100%)",
    color: "#fff",
    fontWeight: 700,
    fontSize: 15,
    cursor: "pointer",
  },

  btnSecondary: {
    height: 38,
    padding: "0 16px",
    borderRadius: 999,
    border: "1px solid #e5e7eb",
    background: "#fff",
    color: "#0f172a",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
  },

  errBox: {
    color: "#b91c1c",
    marginTop: 12,
    fontSize: 13,
    background: "#fef2f2",
    borderRadius: 16,
    padding: "10px 12px",
    border: "1px solid #fecaca",
    fontWeight: 600,
  },

  helpText: {
    marginTop: 16,
    fontSize: 12,
    color: "#9ca3af",
    textAlign: "center",
    fontWeight: 500,
  },
};
